import React from "react";
import { Button, Card, Col } from "react-bootstrap";
import { BsTrash3 } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { AdsListResponse } from "../../../interfaces";
import "../assets/css/ads-list.css";

export const AdsListItem: React.FC<AdsListResponse> = ({ data, deleteModal, strings }) => {
  const navigate = useNavigate();
  return data.map((item) => (
    <Col
      key={item.id}
      xs={12}
      sm={6}
      md={4}
      lg={3}
      xl={3}
      xxl={2}
      style={{ marginBottom: "20px" }}
    >
      <Card>
        <Card.Img
          src={item.image}
          alt={item.description}
          className={"cursor-link"}
          onClick={() => {
            navigate("/adm/ads-update", { state: { adsId: item.id } });
          }}
        />
        <Card.Body>
          <Card.Text>
            <p
              className="ads-name cursor-link text-capitalize"
              onClick={() => {
                navigate("/adm/ads-update", {
                  state: { adsId: item.id },
                });
              }}
            >
              {item.description}
            </p>
            {item.product_name}
            <p>{`${strings?.due_date_label} ${item.due_date}`}</p>
          </Card.Text>
          <Card.Title
            style={{ marginTop: -10 }}
            className={"justify-start-end"}
          >
            <Button
              variant={"outline-danger"}
              onClick={() => deleteModal ? deleteModal(item.id) : null}
            >
              <BsTrash3 />
            </Button>
          </Card.Title>
        </Card.Body>
      </Card>
    </Col>
  ));
};
